import { gql } from "@apollo/client";

export const GET_TIME_ZONES = gql`
  query GetTimeZones {
    getTimeZones {
      id
      name
      timezone
      region {
        id
        name
        is_active
      }
    }
  }
`;
